
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11695',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11695",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.451",
  "dashboard-client-types": "static-1.265",
  "data-fetching-client": "static-1.9523",
  "foundations-components": "static-1.7615",
  "foundations-components-legacy": "static-1.640",
  "foundations-theming": "static-1.4258",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.78",
  "head-dlb": "static-1.4841",
  "hs-test-utils": "static-1.7852",
  "hub-http-shared-msw-handlers": "static-1.9584",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11287",
  "I18n": "static-7.1583",
  "jasmine-runner": "static-1.6316",
  "marketplace-storefront-base": "static-1.11755",
  "quartz": "static-1.6794",
  "react-dlb": "static-1.74",
  "react-rhumb": "static-1.16496",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2709",
  "reporting-testing-lib": "static-1.8649",
  "settings-ui-lib": "static-1.12369",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6821",
  "ui-addon-i18n": "static-1.10990",
  "ui-addon-react-router-dom": "static-1.9391",
  "unified-auth": "static-1.277",
  "unified-auth-core-lib": "static-1.558",
  "usage-tracker": "static-1.7181",
  "usage-tracker-core": "static-1.7031",
  "customer-data-property-utils": "static-1.7926",
  "history": "static-4.47",
  "hub-http": "static-1.6063",
  "integrations-lib": "static-1.15572",
  "marketplace-ui-common": "static-1.19075",
  "property-management-iframe": "static-1.12526",
  "quartz-config": "static-1.572",
  "quartz-core": "static-1.6013",
  "quartz-routing": "static-1.224",
  "quick-fetch": "static-1.3781",
  "react": "static-7.182",
  "rpc-client-utils": "static-1.4484",
  "ts-schema": "static-1.3948",
  "ui-universal-auth": "static-1.8763",
  "UIComponents": "static-3.8234",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.405",
  "hs-promise-rejection-tracking": "static-1.5387",
  "PortalIdParser": "static-2.367",
  "raven": "static-3.5725",
  "raven-hubspot": "static-1.6032",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3272",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3071",
  "quartz-webpack": "static-1.3018",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3884",
  "floating-ui": "static-1.52",
  "foundations-assets": "static-1.4685",
  "foundations-theming-specialty": "static-1.1974",
  "framer-motion": "static-1.68",
  "hs-story-utils": "static-1.9272",
  "react-aria": "static-1.62",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5217",
  "react-virtualized": "static-2.95",
  "StyleGuideUI": "static-3.484",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1340",
  "ui-fonts": "static-1.549",
  "ui-images": "static-2.1109",
  "bend-plugin-foundations-theming": "static-1.2741",
  "foundations-theming-base": "static-1.3243",
  "stylex": "static-1.28",
  "HeadJS": "static-2.721",
  "hs-test-utils-bend-plugin": "static-1.2963",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4172",
  "ai-components-ui-library": "static-1.8479",
  "ai-rendering-library": "static-1.9445",
  "chirp-fetch": "static-1.1729",
  "connections-embed-lib": "static-1.704",
  "copilot-toolkit": "static-1.10650",
  "laboratory-lib": "static-3.7005",
  "marketplace-embed": "static-1.21593",
  "marketplace-ui-details": "static-1.8971",
  "marketplace-ui-reviews": "static-1.19031",
  "marketplace-ui-tracking": "static-1.13246",
  "sanitize-text": "static-1.7991",
  "ui-addon-video-player": "static-1.8542",
  "usage-tracker-multi": "static-1.5595",
  "usage-tracker-session-replay": "static-1.4867",
  "wootric-nps": "static-1.6828",
  "apollo-link-hub-http": "static-2.4497",
  "immer": "static-1.33",
  "immerable": "static-1.4000",
  "highcharts": "static-8.100",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2389",
  "reporting-data": "static-1.66716",
  "cssUtils": "static-1.748",
  "flux-actions": "static-1.314",
  "HubStyle": "static-2.11595",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10057",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10219",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7171",
  "icons": "static-2.629",
  "marketplace-ui-apps-core": "static-1.17608",
  "storybook-react": "static-1.29",
  "trellis-story-utils": "static-1.4366",
  "foundations-components-test-utils": "static-1.5098",
  "quartz-i18n": "static-1.469",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3576",
  "customer-data-objects": "static-1.7497",
  "property-translator": "static-1.5256",
  "frontend-preferences-client": "static-1.7770",
  "hs-promise-utils": "static-1.5439",
  "hubspot-apollo-client": "static-1.4725",
  "integrations-error-boundary-lib": "static-1.12987",
  "integrations-tracking-lib": "static-1.5436",
  "native-integrations-shared-strings": "static-1.7633",
  "reselect": "static-2.16",
  "sanitize": "static-1.4320",
  "superstore": "static-1.4615",
  "ui-shepherd-react": "static-3.9992",
  "ai-settings-ui-library": "static-1.7593",
  "hub-http-janus": "static-1.806",
  "hubspotter-http": "static-1.4521",
  "immutable-less": "static-1.4500",
  "marketplace-ui-client-types": "static-1.16482",
  "nav-meta": "static-1.29062",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10088",
  "ui-addon-upgrades": "static-9.17721",
  "inbound-db-properties-service-client": "static-1.3714",
  "property-management-common": "static-1.4813",
  "ui-addon-iframeable": "static-1.8893",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.496",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.469",
  "quartz-head": "static-1.459",
  "quartz-test": "static-1.469",
  "quartz-tracking": "static-1.173",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2992",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20516",
  "ContentUtils": "static-1.67761",
  "sassPrefix": "static-1.152",
  "avatar-components": "static-1.2338",
  "customer-data-filters-ui": "static-1.39064",
  "customer-data-objects-ui-components": "static-1.12858",
  "customer-data-reference-ui-components": "static-1.12994",
  "embedded-academy-lib": "static-1.13716",
  "ExportDialog": "static-6.10233",
  "highlight.js": "static-1.75",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40773",
  "reporting-snowflake": "static-1.55334",
  "reporting-ui-components": "static-2.63987",
  "reporting-visualizations": "static-1.58792",
  "ui-addon-teams": "static-1.21303",
  "magpie-lib": "static-1.5440",
  "magpie-types": "static-1.4900",
  "simple-logging-lib": "static-1.2896",
  "navigation-components": "static-1.17425",
  "ai-studio-lib": "static-1.11120",
  "developer-experience-shared-components": "static-1.10344",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7837",
  "ui-tool-access": "static-1.9990",
  "usage-based-billing-components-lib": "static-1.8136",
  "usage-tracker-anonymous": "static-1.5598",
  "usage-tracker-public": "static-1.6992",
  "amplitude-session-replay-browser": "static-1.56",
  "inbound-db-meta-service-client": "static-1.3463",
  "persist-promise": "static-1.3554",
  "reference-resolvers": "static-1.8009",
  "ui-extensibility-client-types": "static-1.3788",
  "hubspot-apollo-cache": "static-1.184",
  "universal-page-editor-lib": "static-1.2847",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2308",
  "merchandise-lib": "static-1.261",
  "atom": "static-1.4916",
  "purchase-motions-components": "static-1.5540",
  "salesImages": "static-1.521",
  "batch-promise": "static-1.1397",
  "crm-component-utils": "static-1.38591",
  "crm-properties-common-lib": "static-1.5719",
  "customer-data-properties": "static-1.50904",
  "framework-data-schema-resolvers": "static-1.6719",
  "property-value-citations": "static-1.1518",
  "reference-resolvers-lite": "static-1.7929",
  "navigation-messaging": "static-1.6752",
  "hubspotter-http-shared-msw-handlers": "static-1.9582",
  "cms-field-types": "static-1.4655",
  "content-icons-ui": "static-1.2172",
  "conversations-skeleton-state": "static-1.7094",
  "crm-message-bus": "static-1.42500",
  "customer-data-filters-ui-msw-helpers": "static-1.21499",
  "customer-data-ui-utilities": "static-1.9670",
  "FormUrlGenerator": "static-2.4567",
  "framework-builder-read-service-client": "static-1.3876",
  "framework-data-schema-quick-fetch": "static-1.6624",
  "multi-account-reference-resolvers": "static-1.821",
  "onboarding-tours": "static-1.16330",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13191",
  "academy-common-lib": "static-1.13176",
  "content-assistance-lib": "static-1.7516",
  "dashboard-lib": "static-1.80818",
  "file-manager-components": "static-1.23036",
  "getting-started-shared-tasks": "static-1.18010",
  "hubspot-prosemirror": "static-1.17729",
  "hubspot-prosemirror-plugins": "static-1.17721",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19549",
  "share-with-third-party-component-lib": "static-1.8539",
  "ui-addon-draggable": "static-3.4613",
  "ui-asset-management-lib": "static-1.10771",
  "ui-business-units-lib": "static-1.8878",
  "user-context": "static-1.4946",
  "growth-payments-core": "static-1.24857",
  "reporting-plugins": "static-1.10035",
  "reporting-reports": "static-1.66394",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.571",
  "codemirror": "static-5.91",
  "feedback-loader": "static-1.28958",
  "react-codemirror": "static-1.10472",
  "apps-service-types": "static-1.3723",
  "oauth-service-types": "static-1.4093",
  "onboarding-scopes": "static-1.6309",
  "onboarding-tours-client": "static-1.4544",
  "platform-infra-nav-components": "static-1.7534",
  "subscription-experience-data-types": "static-1.14641",
  "crm-record-cards-service-types": "static-1.3485",
  "location-customization-utils-lib": "static-1.8711",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4345",
  "nav-client-types": "static-1.2203",
  "purchase-motions-api": "static-1.5543",
  "signup-constants": "static-1.18507",
  "signup-ui-url-generator": "static-2.7880",
  "trials-service-types": "static-1.3746",
  "card-properties-lib": "static-1.43655",
  "commerce-subscription-lib": "static-1.36590",
  "crm-actions": "static-1.6153",
  "crm-cards-sdk": "static-1.43058",
  "customer-data-properties-shared-msw-handlers": "static-1.8911",
  "customer-data-tracking": "static-1.6728",
  "hs-entities": "static-1.529",
  "pulse": "static-1.365",
  "calling-global-api": "static-1.63842",
  "calling-internal-common": "static-1.31145",
  "calling-lifecycle-internal": "static-1.65224",
  "calling-lifecycle-messages": "static-1.57518",
  "commerce-products-lib": "static-1.8977",
  "conditional-properties-service-client": "static-1.3666",
  "crm-links": "static-1.6114",
  "external-options-client-types": "static-1.4027",
  "google-libphonenumber": "static-1.34",
  "inbounddb-objects-service-types": "static-1.4091",
  "meetings-icalendar-utils-lib": "static-1.478",
  "multi-currency-client-types": "static-1.3559",
  "object-builder-ui-client": "static-1.48152",
  "pipeline-validation-client-types": "static-1.3832",
  "smart-property-lib": "static-1.6113",
  "tiered-pricing": "static-1.897",
  "ui-addon-form-validation": "static-1.10839",
  "crm-pipelines-api-client-types": "static-1.4008",
  "react-dnd-compat": "static-1.4466",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5204",
  "growth-onboarding-confetti": "static-1.2918",
  "growth-onboarding-next-action-utils": "static-1.1416",
  "onboarding-tours-utils": "static-1.396",
  "ui-shepherd-tracker": "static-1.7373",
  "academy-service-client": "static-1.3526",
  "final-form": "static-1.66",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28065",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8230",
  "video-components-external": "static-1.10701",
  "video-data-lib": "static-1.34359",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8409",
  "payment-link-components": "static-1.23061",
  "ui-addon-emoji-picker": "static-1.9733",
  "EmailSignatureEditor": "static-1.23980",
  "viral-links-lib": "static-1.6884",
  "data-token-picker": "static-1.16121",
  "FileManagerLib": "static-1.38676",
  "react-flip-move": "static-1.66",
  "timezone-utils": "static-2.5090",
  "getting-started-shared-tasks-store": "static-1.17128",
  "campaign-roi-lib": "static-1.8422",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.238",
  "eligibility-engine-service-types": "static-1.3027",
  "crm_data": "static-4.91400",
  "customer-data-sidebar": "static-2.45538",
  "enrichment-properties-lib": "static-1.15231",
  "commerce-billing-lib": "static-1.18619",
  "commerce-shared-components-lib": "static-1.18073",
  "commerce-tools-ui-lib": "static-1.9909",
  "crm-fe-perf": "static-1.22751",
  "directed-graph": "static-1.785",
  "event-emitter": "static-1.793",
  "fast-json-patch": "static-1.59",
  "calling-error-reporting": "static-1.31151",
  "shared-worker-versioning": "static-1.10885",
  "calling-usage-tracker": "static-1.6387",
  "voice-sms-access-library": "static-1.379",
  "commerce-permissions": "static-1.608",
  "products-iframe-lib": "static-1.7451",
  "products-ui-components-shared-msw-handlers": "static-1.9966",
  "breeze-intelligence-kit": "static-1.5390",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9667",
  "policy-lib": "static-1.6623",
  "react-tinymce": "static-1.54748",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9730",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53874",
  "tinymce-plugins": "static-1.56988",
  "tinymce-themes": "static-1.55844",
  "growth-onboarding-next-action-components": "static-1.1444",
  "user-context-client": "static-1.4477",
  "growth-onboarding-feedback-components": "static-1.6427",
  "content-media-composition-data-lib": "static-1.11623",
  "content-media-compositions": "static-2.15630",
  "media-bridge-lib": "static-1.18643",
  "commerce-tours-lib": "static-1.5788",
  "growth-onboarding-reliability": "static-1.4932",
  "sales-checkout-service-client": "static-1.3513",
  "draft-convert": "static-2.69",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.74",
  "draft-plugins": "static-2.21386",
  "sales-email-signature-service-client": "static-1.3689",
  "audio-components": "static-1.5680",
  "FileManagerCore": "static-1.38535",
  "FileManagerImages": "static-1.36187",
  "video-components": "static-1.12704",
  "crm_universal": "static-1.21737",
  "customer-data-email": "static-1.17748",
  "card-payment-highlight-lib": "static-1.36643",
  "card-subscription-highlight-lib": "static-1.39013",
  "commerce-contract-lib": "static-1.11363",
  "customer-data-content": "static-1.26957",
  "invoices-highlight-card-lib": "static-1.54177",
  "orders-highlight-card-lib": "static-1.20983",
  "products-highlight-card-lib": "static-1.17261",
  "project-storage": "static-1.4579",
  "quotes-highlight-card-lib": "static-1.71352",
  "crm-source-interpretation-lib": "static-1.5177",
  "utility-belt": "static-1.2386",
  "customer-data-associations": "static-1.7169",
  "framework-data-table": "static-2.11524",
  "payments-enrollment-embed-lib": "static-1.22147",
  "customer-data-rte": "static-1.32556",
  "cv-backend-services": "static-1.1514",
  "growth-onboarding-empty-states": "static-1.5436",
  "InboxConnectUtils": "static-4.14341",
  "payments-post-enroll-local-storage-lib": "static-1.4960",
  "qrcode-generator": "static-1.65",
  "quotes-client-types": "static-1.37441",
  "calling-orchestration-schema": "static-1.35156",
  "sales-views-client-types": "static-1.4132",
  "hub-http-contrib": "static-1.2889",
  "interframe": "static-3.4617",
  "tinymce-data": "static-1.39959",
  "ui-addon-sales-email": "static-1.5060",
  "layout-dnd-components": "static-1.12127",
  "layout-dnd-utils": "static-1.11102",
  "ui-brand-identity-lib": "static-1.14211",
  "NamespacedHubStyle": "static-2.8939",
  "hls.js": "static-1.35",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4377",
  "video-embed": "static-1.35193",
  "social-insights-client-types": "static-1.21498",
  "sequences-lib": "static-1.7760",
  "ui-gdpr-components": "static-1.10193",
  "products-ui-components": "static-1.39496",
  "quotes-ui-lib": "static-1.80072",
  "SalesContentIndexUI": "static-3.8971",
  "accounting-integrations-ui-components": "static-1.6801",
  "invoices-ui-lib": "static-1.54193",
  "commerce-products-api": "static-1.2024",
  "SafeStorage": "static-1.4248",
  "invoices-iframe-lib": "static-1.56251",
  "quotes-modal-lib": "static-1.102029",
  "deal-intel-decorators": "static-1.1425",
  "tanstack-virtual": "static-1.26",
  "stripe-embedded-components": "static-1.7216",
  "draft-content-plugins": "static-1.27823",
  "ContentData": "static-1.67836",
  "layout-data-lib": "static-1.9427",
  "outpost": "static-1.4046",
  "sequences-client-types-lib": "static-1.7617",
  "commerce-tax-lib": "static-1.363",
  "property-description-translator": "static-1.3702",
  "FireAlarmUi": "static-1.4376",
  "sales-templates-service-types-lib": "static-1.4035",
  "commerce-analytics-service-client": "static-1.3501",
  "totals-ui-components": "static-1.23111",
  "deal-intel-utils": "static-1.1429",
  "stripe-connect-js": "static-1.65",
  "advanced-menus-core": "static-1.14885",
  "advanced-menus-lib": "static-1.11854",
  "ui-memberships-settings-lib": "static-1.33573",
  "commerce-totals-service-types": "static-1.3683",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14884",
  "simple-menus-lib": "static-1.16401"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11695",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.451",
  "dashboard-client-types": "/dashboard-client-types/static-1.265",
  "data-fetching-client": "/data-fetching-client/static-1.9523",
  "foundations-components": "/foundations-components/static-1.7615",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.640",
  "foundations-theming": "/foundations-theming/static-1.4258",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.78",
  "head-dlb": "/head-dlb/static-1.4841",
  "hs-test-utils": "/hs-test-utils/static-1.7852",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9584",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11287",
  "I18n": "/I18n/static-7.1583",
  "jasmine-runner": "/jasmine-runner/static-1.6316",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11755",
  "quartz": "/quartz/static-1.6794",
  "react-dlb": "/react-dlb/static-1.74",
  "react-rhumb": "/react-rhumb/static-1.16496",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2709",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8649",
  "settings-ui-lib": "/settings-ui-lib/static-1.12369",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6821",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10990",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9391",
  "unified-auth": "/unified-auth/static-1.277",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.558",
  "usage-tracker": "/usage-tracker/static-1.7181",
  "usage-tracker-core": "/usage-tracker-core/static-1.7031",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7926",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6063",
  "integrations-lib": "/integrations-lib/static-1.15572",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19075",
  "property-management-iframe": "/property-management-iframe/static-1.12526",
  "quartz-config": "/quartz-config/static-1.572",
  "quartz-core": "/quartz-core/static-1.6013",
  "quartz-routing": "/quartz-routing/static-1.224",
  "quick-fetch": "/quick-fetch/static-1.3781",
  "react": "/react/static-7.182",
  "rpc-client-utils": "/rpc-client-utils/static-1.4484",
  "ts-schema": "/ts-schema/static-1.3948",
  "ui-universal-auth": "/ui-universal-auth/static-1.8763",
  "UIComponents": "/UIComponents/static-3.8234",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.405",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "raven": "/raven/static-3.5725",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3272",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3071",
  "quartz-webpack": "/quartz-webpack/static-1.3018",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3884",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-assets": "/foundations-assets/static-1.4685",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1974",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-story-utils": "/hs-story-utils/static-1.9272",
  "react-aria": "/react-aria/static-1.62",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5217",
  "react-virtualized": "/react-virtualized/static-2.95",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1340",
  "ui-fonts": "/ui-fonts/static-1.549",
  "ui-images": "/ui-images/static-2.1109",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2741",
  "foundations-theming-base": "/foundations-theming-base/static-1.3243",
  "stylex": "/stylex/static-1.28",
  "HeadJS": "/HeadJS/static-2.721",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2963",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4172",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8479",
  "ai-rendering-library": "/ai-rendering-library/static-1.9445",
  "chirp-fetch": "/chirp-fetch/static-1.1729",
  "connections-embed-lib": "/connections-embed-lib/static-1.704",
  "copilot-toolkit": "/copilot-toolkit/static-1.10650",
  "laboratory-lib": "/laboratory-lib/static-3.7005",
  "marketplace-embed": "/marketplace-embed/static-1.21593",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8971",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19031",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13246",
  "sanitize-text": "/sanitize-text/static-1.7991",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8542",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5595",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4867",
  "wootric-nps": "/wootric-nps/static-1.6828",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4497",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4000",
  "highcharts": "/highcharts/static-8.100",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2389",
  "reporting-data": "/reporting-data/static-1.66716",
  "cssUtils": "/cssUtils/static-1.748",
  "flux-actions": "/flux-actions/static-1.314",
  "HubStyle": "/HubStyle/static-2.11595",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10057",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10219",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7171",
  "icons": "/icons/static-2.629",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17608",
  "storybook-react": "/storybook-react/static-1.29",
  "trellis-story-utils": "/trellis-story-utils/static-1.4366",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5098",
  "quartz-i18n": "/quartz-i18n/static-1.469",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3576",
  "customer-data-objects": "/customer-data-objects/static-1.7497",
  "property-translator": "/property-translator/static-1.5256",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7770",
  "hs-promise-utils": "/hs-promise-utils/static-1.5439",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4725",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12987",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5436",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7633",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4320",
  "superstore": "/superstore/static-1.4615",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9992",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7593",
  "hub-http-janus": "/hub-http-janus/static-1.806",
  "hubspotter-http": "/hubspotter-http/static-1.4521",
  "immutable-less": "/immutable-less/static-1.4500",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16482",
  "nav-meta": "/nav-meta/static-1.29062",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10088",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17721",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3714",
  "property-management-common": "/property-management-common/static-1.4813",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8893",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.496",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.469",
  "quartz-head": "/quartz-head/static-1.459",
  "quartz-test": "/quartz-test/static-1.469",
  "quartz-tracking": "/quartz-tracking/static-1.173",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2992",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20516",
  "ContentUtils": "/ContentUtils/static-1.67761",
  "sassPrefix": "/sassPrefix/static-1.152",
  "avatar-components": "/avatar-components/static-1.2338",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39064",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12858",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12994",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13716",
  "ExportDialog": "/ExportDialog/static-6.10233",
  "highlight.js": "/highlight.js/static-1.75",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40773",
  "reporting-snowflake": "/reporting-snowflake/static-1.55334",
  "reporting-ui-components": "/reporting-ui-components/static-2.63987",
  "reporting-visualizations": "/reporting-visualizations/static-1.58792",
  "ui-addon-teams": "/ui-addon-teams/static-1.21303",
  "magpie-lib": "/magpie-lib/static-1.5440",
  "magpie-types": "/magpie-types/static-1.4900",
  "simple-logging-lib": "/simple-logging-lib/static-1.2896",
  "navigation-components": "/navigation-components/static-1.17425",
  "ai-studio-lib": "/ai-studio-lib/static-1.11120",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10344",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7837",
  "ui-tool-access": "/ui-tool-access/static-1.9990",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8136",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5598",
  "usage-tracker-public": "/usage-tracker-public/static-1.6992",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3463",
  "persist-promise": "/persist-promise/static-1.3554",
  "reference-resolvers": "/reference-resolvers/static-1.8009",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3788",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.184",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2847",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2308",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "atom": "/atom/static-1.4916",
  "purchase-motions-components": "/purchase-motions-components/static-1.5540",
  "salesImages": "/salesImages/static-1.521",
  "batch-promise": "/batch-promise/static-1.1397",
  "crm-component-utils": "/crm-component-utils/static-1.38591",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5719",
  "customer-data-properties": "/customer-data-properties/static-1.50904",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6719",
  "property-value-citations": "/property-value-citations/static-1.1518",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7929",
  "navigation-messaging": "/navigation-messaging/static-1.6752",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9582",
  "cms-field-types": "/cms-field-types/static-1.4655",
  "content-icons-ui": "/content-icons-ui/static-1.2172",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7094",
  "crm-message-bus": "/crm-message-bus/static-1.42500",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21499",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9670",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4567",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3876",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6624",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.821",
  "onboarding-tours": "/onboarding-tours/static-1.16330",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13191",
  "academy-common-lib": "/academy-common-lib/static-1.13176",
  "content-assistance-lib": "/content-assistance-lib/static-1.7516",
  "dashboard-lib": "/dashboard-lib/static-1.80818",
  "file-manager-components": "/file-manager-components/static-1.23036",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18010",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17729",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17721",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19549",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8539",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4613",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10771",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8878",
  "user-context": "/user-context/static-1.4946",
  "growth-payments-core": "/growth-payments-core/static-1.24857",
  "reporting-plugins": "/reporting-plugins/static-1.10035",
  "reporting-reports": "/reporting-reports/static-1.66394",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.571",
  "codemirror": "/codemirror/static-5.91",
  "feedback-loader": "/feedback-loader/static-1.28958",
  "react-codemirror": "/react-codemirror/static-1.10472",
  "apps-service-types": "/apps-service-types/static-1.3723",
  "oauth-service-types": "/oauth-service-types/static-1.4093",
  "onboarding-scopes": "/onboarding-scopes/static-1.6309",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4544",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7534",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14641",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3485",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8711",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4345",
  "nav-client-types": "/nav-client-types/static-1.2203",
  "purchase-motions-api": "/purchase-motions-api/static-1.5543",
  "signup-constants": "/signup-constants/static-1.18507",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7880",
  "trials-service-types": "/trials-service-types/static-1.3746",
  "card-properties-lib": "/card-properties-lib/static-1.43655",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36590",
  "crm-actions": "/crm-actions/static-1.6153",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43058",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8911",
  "customer-data-tracking": "/customer-data-tracking/static-1.6728",
  "hs-entities": "/hs-entities/static-1.529",
  "pulse": "/pulse/static-1.365",
  "calling-global-api": "/calling-global-api/static-1.63842",
  "calling-internal-common": "/calling-internal-common/static-1.31145",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65224",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57518",
  "commerce-products-lib": "/commerce-products-lib/static-1.8977",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3666",
  "crm-links": "/crm-links/static-1.6114",
  "external-options-client-types": "/external-options-client-types/static-1.4027",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4091",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.478",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3559",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48152",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3832",
  "smart-property-lib": "/smart-property-lib/static-1.6113",
  "tiered-pricing": "/tiered-pricing/static-1.897",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10839",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4008",
  "react-dnd-compat": "/react-dnd-compat/static-1.4466",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5204",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2918",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1416",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.396",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7373",
  "academy-service-client": "/academy-service-client/static-1.3526",
  "final-form": "/final-form/static-1.66",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28065",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8230",
  "video-components-external": "/video-components-external/static-1.10701",
  "video-data-lib": "/video-data-lib/static-1.34359",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8409",
  "payment-link-components": "/payment-link-components/static-1.23061",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9733",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23980",
  "viral-links-lib": "/viral-links-lib/static-1.6884",
  "data-token-picker": "/data-token-picker/static-1.16121",
  "FileManagerLib": "/FileManagerLib/static-1.38676",
  "react-flip-move": "/react-flip-move/static-1.66",
  "timezone-utils": "/timezone-utils/static-2.5090",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17128",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8422",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.238",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3027",
  "crm_data": "/crm_data/static-4.91400",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45538",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15231",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18619",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18073",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9909",
  "crm-fe-perf": "/crm-fe-perf/static-1.22751",
  "directed-graph": "/directed-graph/static-1.785",
  "event-emitter": "/event-emitter/static-1.793",
  "fast-json-patch": "/fast-json-patch/static-1.59",
  "calling-error-reporting": "/calling-error-reporting/static-1.31151",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10885",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6387",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.379",
  "commerce-permissions": "/commerce-permissions/static-1.608",
  "products-iframe-lib": "/products-iframe-lib/static-1.7451",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9966",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5390",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9667",
  "policy-lib": "/policy-lib/static-1.6623",
  "react-tinymce": "/react-tinymce/static-1.54748",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9730",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53874",
  "tinymce-plugins": "/tinymce-plugins/static-1.56988",
  "tinymce-themes": "/tinymce-themes/static-1.55844",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1444",
  "user-context-client": "/user-context-client/static-1.4477",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6427",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11623",
  "content-media-compositions": "/content-media-compositions/static-2.15630",
  "media-bridge-lib": "/media-bridge-lib/static-1.18643",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5788",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4932",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3513",
  "draft-convert": "/draft-convert/static-2.69",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.74",
  "draft-plugins": "/draft-plugins/static-2.21386",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3689",
  "audio-components": "/audio-components/static-1.5680",
  "FileManagerCore": "/FileManagerCore/static-1.38535",
  "FileManagerImages": "/FileManagerImages/static-1.36187",
  "video-components": "/video-components/static-1.12704",
  "crm_universal": "/crm_universal/static-1.21737",
  "customer-data-email": "/customer-data-email/static-1.17748",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36643",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39013",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11363",
  "customer-data-content": "/customer-data-content/static-1.26957",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54177",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20983",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17261",
  "project-storage": "/project-storage/static-1.4579",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71352",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5177",
  "utility-belt": "/utility-belt/static-1.2386",
  "customer-data-associations": "/customer-data-associations/static-1.7169",
  "framework-data-table": "/framework-data-table/static-2.11524",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22147",
  "customer-data-rte": "/customer-data-rte/static-1.32556",
  "cv-backend-services": "/cv-backend-services/static-1.1514",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5436",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14341",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4960",
  "qrcode-generator": "/qrcode-generator/static-1.65",
  "quotes-client-types": "/quotes-client-types/static-1.37441",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35156",
  "sales-views-client-types": "/sales-views-client-types/static-1.4132",
  "hub-http-contrib": "/hub-http-contrib/static-1.2889",
  "interframe": "/interframe/static-3.4617",
  "tinymce-data": "/tinymce-data/static-1.39959",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5060",
  "layout-dnd-components": "/layout-dnd-components/static-1.12127",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11102",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14211",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8939",
  "hls.js": "/hls.js/static-1.35",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4377",
  "video-embed": "/video-embed/static-1.35193",
  "social-insights-client-types": "/social-insights-client-types/static-1.21498",
  "sequences-lib": "/sequences-lib/static-1.7760",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10193",
  "products-ui-components": "/products-ui-components/static-1.39496",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80072",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8971",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6801",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54193",
  "commerce-products-api": "/commerce-products-api/static-1.2024",
  "SafeStorage": "/SafeStorage/static-1.4248",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56251",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102029",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1425",
  "tanstack-virtual": "/tanstack-virtual/static-1.26",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7216",
  "draft-content-plugins": "/draft-content-plugins/static-1.27823",
  "ContentData": "/ContentData/static-1.67836",
  "layout-data-lib": "/layout-data-lib/static-1.9427",
  "outpost": "/outpost/static-1.4046",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7617",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.363",
  "property-description-translator": "/property-description-translator/static-1.3702",
  "FireAlarmUi": "/FireAlarmUi/static-1.4376",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4035",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3501",
  "totals-ui-components": "/totals-ui-components/static-1.23111",
  "deal-intel-utils": "/deal-intel-utils/static-1.1429",
  "stripe-connect-js": "/stripe-connect-js/static-1.65",
  "advanced-menus-core": "/advanced-menus-core/static-1.14885",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11854",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33573",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3683",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14884",
  "simple-menus-lib": "/simple-menus-lib/static-1.16401"
}
};
